import React, { useState } from 'react';
import { toast } from 'sonner';
import { Drawer, field, safe, useApi } from './ui';

const History = ({ item, onClose }) => {
  const { call } = useApi();
  const [rows, setRows] = useState([]);
  React.useEffect(() => { call('get', `/purchasing/items/${item.id}/history`).then(setRows); }, [item.id, call]);
  return (
    <Drawer title={`${item.name} · history`} onClose={onClose} testid="part-history">
      <table className="w-full text-sm"><tbody>{rows.map((r) => (
        <tr key={r.id} className="border-t"><td className="py-1.5">{r.transaction_date?.slice(0, 10)}</td>
          <td className={r.quantity_change >= 0 ? 'text-emerald-700' : 'text-red-600'}>{r.quantity_change >= 0 ? '+' : ''}{r.quantity_change}</td>
          <td>{r.ref || r.action}</td><td className="text-slate-500">{r.user_name || r.user_email}</td><td className="text-xs text-slate-500">{r.notes}</td></tr>))}</tbody></table>
    </Drawer>
  );
};

export const PartsTab = ({ items, vendors, reload }) => {
  const { call } = useApi();
  const [hist, setHist] = useState(null);
  const [q, setQ] = useState('');
  const save = safe(async (it, patch) => { await call('patch', `/purchasing/items/${it.id}`, patch); toast.success('Saved'); reload(); });
  const num = (it, k) => (
    <input type="number" min="0" defaultValue={it[k] ?? ''} onBlur={(e) => e.target.value !== String(it[k] ?? '') && save(it, { [k]: Number(e.target.value) || 0 })}
      className={`${field} w-20 py-1 text-right`} data-testid={`part-${k}-${it.id}`} />
  );
  const rows = items.filter((i) => !q || i.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <div className="space-y-3" data-testid="parts-tab">
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search parts" className={`${field} max-w-xs`} data-testid="part-search" />
      <div className="overflow-x-auto rounded-xl border bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase text-slate-500"><tr><th className="p-3">Part</th><th className="p-3">Stock</th><th className="p-3">Min</th><th className="p-3">Max</th><th className="p-3">MRP ₹</th><th className="p-3">Preferred vendor</th><th className="p-3" /></tr></thead>
          <tbody>{rows.map((it) => (
            <tr key={it.id} className="border-t" data-testid={`part-row-${it.id}`}>
              <td className="p-3 font-medium">{it.name}<p className="text-xs text-slate-500">{it.brand}</p></td>
              <td className="p-3 whitespace-nowrap" data-testid={`part-stock-${it.id}`}><b className={Number(it.quantity) <= Number(it.safety_stock || 0) ? 'text-red-600' : ''}>{it.quantity}</b> in stock{it.on_order ? <span className="text-sky-700"> · {it.on_order} on order</span> : ''}</td>
              <td className="p-3">{num(it, 'safety_stock')}</td><td className="p-3">{num(it, 'max_stock')}</td><td className="p-3">{num(it, 'mrp')}</td>
              <td className="p-3"><select value={it.preferred_vendor_id || ''} onChange={(e) => save(it, { preferred_vendor_id: e.target.value })} className={`${field} py-1`} data-testid={`part-vendor-${it.id}`}>
                <option value="">—</option>{vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}</select></td>
              <td className="p-3"><button onClick={() => setHist(it)} className="text-xs font-semibold text-teal-700" data-testid={`part-history-${it.id}`}>History</button></td>
            </tr>))}</tbody>
        </table>
      </div>
      {hist && <History item={hist} onClose={() => setHist(null)} />}
    </div>
  );
};
